import type { NewsType } from '@/types/domains/index';

export class LayoutPresenter {
  getImportantNews(): NewsType.News[] {
    return useNews().getImportantNews();
  }

  async logout(): Promise<void> {
    await useAuth().logout();
  }
}
